import { array } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { primitiveTypeUniq } from '../primitiveTypeUniq';

export const getItemByCommonPropertyValue = <TObject extends object, TKey extends keyof TObject>(property: TKey) =>
    flow(
        array.map((object: TObject) => object[property]),
        primitiveTypeUniq,
        (values) => (values.length === 1 ? values[0] : null)
    );
